import { render } from "./MenuSidebar.vue?vue&type=template&id=325a3440&scoped=true"
import script from "./MenuSidebar.vue?vue&type=script&lang=js"
export * from "./MenuSidebar.vue?vue&type=script&lang=js"

import "./MenuSidebar.vue?vue&type=style&index=0&id=325a3440&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-325a3440"]])

export default __exports__